const mixins = {
    data() {
        return {
            scrollY: null
        }
    },
    mounted() {
        this.setScrollY()
        window.addEventListener('scroll', () => this.setScrollY())
    },
    methods:{
        setScrollY() {
            this.scrollY = Math.round(window.scrollY)
        }
    }
}

export default mixins